module.exports = __webpack_public_path__ + "media/src/images/partners/reutlingen-fd4218f90384248e7fa4807eded7a9c1.jpg";